import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllEmailPreferencesAsync, getEmailPreferenceByIdAsync, createEmailPreferenceAsync, updateEmailPreferenceAsync } from './emailPreferencesThunk';
const initialState = {
    status: APIStatus.IDLE,
    emailPreferences: [],
    selectedEmailPreference: null
};
export const emailPreferencesSlice = createSlice({
    name: 'emailPreferences',
    initialState,
    reducers: {
        resetEmailPreferencesApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSelectedEmailPreference(state) {
            state.selectedEmailPreference = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get All
            .addCase(getAllEmailPreferencesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEmailPreferencesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.emailPreferences = action.payload;
        })
            .addCase(getAllEmailPreferencesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        })
            // Get By Id
            .addCase(getEmailPreferenceByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailPreferenceByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedEmailPreference = action.payload;
        })
            .addCase(getEmailPreferenceByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        })
            // Create
            .addCase(createEmailPreferenceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createEmailPreferenceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.emailPreferences.push(action.payload);
        })
            .addCase(createEmailPreferenceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        })
            // Update
            .addCase(updateEmailPreferenceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateEmailPreferenceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            const index = state.emailPreferences.findIndex((ep) => ep.id === action.payload.id);
            if (index !== -1) {
                state.emailPreferences[index] = action.payload;
            }
            if (state.selectedEmailPreference?.id === action.payload.id) {
                state.selectedEmailPreference = action.payload;
            }
        })
            .addCase(updateEmailPreferenceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
    }
});
export const { resetEmailPreferencesApiState, clearSelectedEmailPreference } = emailPreferencesSlice.actions;
export default emailPreferencesSlice.reducer;
